export const PURCHASEORDERMONITORINGMANAGEMENT_FILE = 'PURCHASEORDERMONITORINGMANAGEMENT_FILE';
// 更新
export const PURCHASEORDERMONITORINGMANAGEMENT_UPDATE = 'PURCHASEORDERMONITORINGMANAGEMENT_UPDATE';
